/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does a space sometimes become %20 and other times a +?`)
};

const es_ue_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué a veces un espacio se convierte en %20 y otras veces en +?`)
};

const de_ue_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum wird ein Leerzeichen manchmal %20 und manchmal ein +?`)
};

const nl_ue_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom wordt een spatie soms %20 en soms een +?`)
};

const fr_ue_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi un espace devient-il parfois %20 et d'autres fois un + ?`)
};

const it_ue_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché uno spazio a volte diventa %20 e altre volte +?`)
};

const pt_br2_ue_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que um espaço às vezes se torna %20 e outras vezes um +?`)
};

const pt_ue_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que um espaço às vezes se torna %20 e outras vezes um +?`)
};

const ja_ue_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スペースが時々 %20 になり、他の時には + になるのはなぜですか?`)
};

const zh_ue_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么空格有时会变成 %20，有时又会变成 +？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_faq4_q", locale)
	if (locale === "en") return en_ue_faq4_q(inputs)
	if (locale === "es") return es_ue_faq4_q(inputs)
	if (locale === "de") return de_ue_faq4_q(inputs)
	if (locale === "nl") return nl_ue_faq4_q(inputs)
	if (locale === "fr") return fr_ue_faq4_q(inputs)
	if (locale === "it") return it_ue_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_ue_faq4_q(inputs)
	if (locale === "pt") return pt_ue_faq4_q(inputs)
	if (locale === "ja") return ja_ue_faq4_q(inputs)
	return zh_ue_faq4_q(inputs)
};